import { format, parseISO } from "date-fns";

// ─── buildShipmentFieldConfig ─────────────────────────────────────────────────
export function buildShipmentFieldConfig(appointmentData, mustPickUpBy, mustDeliverBy, shipmentData) {
  return {
    shipmentNumber:    { label: "Shipment Number",       value: appointmentData.shipmentNumber,                                              inputType: "text",   isReadOnly: true },
    stopNumber:        { label: "Stop Number",           value: appointmentData.stopNumber,                                                  inputType: "number"                  },
    poNumber:          { label: "PO Number",             value: appointmentData.poNumber,                                                    inputType: "text"                    },
    salesOrderNumber:  { label: "SO Number",             value: appointmentData?.salesOrderNumber ?? shipmentData?.salesOrderNumber ?? "—",  inputType: "text"                    },
    shipperOfficeCode: { label: "Office Code",           value: appointmentData.officeCodeShipper,                                          inputType: "text"                    },
    companyName:       { label: "Company",               value: appointmentData.companyName,                                                 inputType: "text"                    },
    addressLine1:      { label: "Address Line 1",        value: appointmentData.addressLine1,                                               inputType: "text"                    },
    addressLine2:      { label: "Address Line 2",        value: appointmentData.addressLine2,                                               inputType: "text"                    },
    city:              { label: "City",                  value: appointmentData.city,                                                        inputType: "text"                    },
    state:             { label: "State",                 value: appointmentData.state,                                                       inputType: "text"                    },
    zipCode:           { label: "Zip Code",              value: appointmentData.zipCode,                                                     inputType: "text"                    },
    country:           { label: "Country",               value: appointmentData.country,                                                     inputType: "text"                    },
    carrierName:       { label: "Carrier",               value: appointmentData.carrierName,                                                 inputType: "text",   isReadOnly: true },
    mustPickUpBy:      { label: "Planned Pickup Date",   value: mustPickUpBy,                                                                inputType: "text"                    },
    mustDeliverBy:     { label: "Planned Delivery Date", value: mustDeliverBy,                                                              inputType: "text"                    },
  };
}

// ─── buildCarrierFieldConfig ──────────────────────────────────────────────────
export function buildCarrierFieldConfig(appointmentCarrier) {
  return {
    carrierName:   { label: "Carrier Name",   value: appointmentCarrier.carrierName,   inputType: "text", isReadOnly: true },
    driverName:    { label: "Driver Name",    value: appointmentCarrier.driverName,    inputType: "text"                  },
    trailerNumber: { label: "Trailer Number", value: appointmentCarrier.trailerNumber, inputType: "text"                  },
  };
}

// ─── buildInfoData ────────────────────────────────────────────────────────────
export function buildInfoData({
  selectedLocation, locationOptions,
  selectedWarehouse, warehouseOptions,
  date, isReadOnlyMode, isEditMode, isShipper, warehouseFieldType, calculatedMinDate,
}) {
  const formatDisplayDate = (d) => {
    try {
      return d
        ? format(parseISO(d + "T00:00:00"), "MMM dd, yyyy")
        : "—";
    } catch {
      return d || "—";
    }
  };

  return {
    Location: {
      type:    "text",
      label:   "Location",
      value:   selectedLocation?.locationName || "—",
      options: locationOptions.map((loc) => loc.locationName),
      readonly: true,
    },
    Warehouse: {
      type:    isReadOnlyMode ? "text" : warehouseFieldType,
      label:   "Warehouse",
      value:   selectedWarehouse?.locationName || "—",
      options: warehouseOptions.map((wh) => wh.locationName),
      readonly: isReadOnlyMode ? true : !isShipper,
    },
    "Appointment Date": {
      type:    isReadOnlyMode ? "text" : (isEditMode ? "date" : "text"),
      label:   "Appointment Date",
      value:   date
        ? (isEditMode && !isReadOnlyMode ? date : formatDisplayDate(date))
        : "—",
      minDate: calculatedMinDate,
      readonly: isReadOnlyMode,
    },
  };
}